interface HeroProps {
  headline: string;
  subheadline: string;
  description: string;
  cta: {
    primary: {
      text: string;
      url: string;
    };
  };
}

export default function Hero({ headline, subheadline, description, cta }: HeroProps) {
  return (
    <div className="relative bg-gradient-to-br from-blue-600 to-purple-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
        <div className="text-center">
          <h1 className="text-5xl sm:text-6xl font-bold mb-6">{headline}</h1>
          <p className="text-2xl sm:text-3xl font-medium mb-4 text-blue-100">
            {subheadline}
          </p>
          <p className="text-lg sm:text-xl mb-10 text-blue-50 max-w-3xl mx-auto">
            {description}
          </p>
          <a
            href={cta.primary.url}
            className="inline-block px-8 py-4 bg-white text-blue-600 font-bold text-lg rounded-lg hover:bg-gray-100 transition shadow-lg"
          >
            {cta.primary.text}
          </a>
        </div>
      </div>
    </div>
  );
}
